<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 100%; max-width: 80vw;':''">
    <q-card-section class="row items-center q-pb-none">
      <div>
        <div class="text-bold">{{ CustomerInfo.Cs_Name }}
          <q-badge v-if="CustomerInfo.State_Name!=='' && CustomerInfo.State_Name!=null" align="top"
                   :label="CustomerInfo.State_Name" color="brown-5"/>
          <q-badge v-if="CustomerInfo.City_Name!=='' && CustomerInfo.City_Name!=null" align="top"
                   :label="CustomerInfo.City_Name" color="brown-5" class="q-ml-xs"/>
        </div>
        <div class="row q-ml-xs">
          <q-badge color="deep-orange-14"><i>شناسه(</i><b>{{ CustomerInfo.Cs_Code }}</b><i>)</i>
          </q-badge>
          <q-badge v-if="remCredit > 0" color='red-14' class="q-ml-xs"><i>بدهکاری(</i><b
              dir="ltr">{{ Math.abs(remCredit) | toCurrency }}</b><i>) ریال</i>
          </q-badge>
          <q-badge v-if="remCredit < 0" color='teal' class="q-ml-xs"><i>بستانکاری(</i><b
              dir="ltr">({{ Math.abs(remCredit) | toCurrency }})</b><i>) ریال</i>
          </q-badge>
        </div>
      </div>
      <q-space/>
      <q-btn icon="close" flat round dense v-close-popup/>
    </q-card-section>

    <q-card-section class="no-padding" v-if="$q.screen.lt.md">
      <q-card v-for="(item, index) in items" :key="index" class="q-ma-xs">
        <q-card-section>
          <q-chip square icon="account_balance"
                  :label="item.BankName">
            <q-badge :color="item.RecoveryDate?'green':'red'" text-color="white" :label="item.BranchName"/>
            <q-tooltip>
              {{ item.RecoveryDate ? 'پاس شده' : 'پاس نشده' }}
            </q-tooltip>
          </q-chip>
          <q-chip square icon="event"
                  color="deep-orange" text-color="white"
                  :label="formatDateString(item.ExpiryDate)">
            <q-tooltip>
              تاریخ چک
            </q-tooltip>
          </q-chip>
          <q-chip square icon="event"
                  v-if="item.RecoveryDate"
                  color="purple" text-color="white"
                  :label="formatDateString(item.RecoveryDate)">
            <q-tooltip>
              تاریخ رسید وجه در صندوق
            </q-tooltip>
          </q-chip>
          <q-chip square icon="pin"
                  color="teal" text-color="white"
                  :label="item.ChequeNum">
            <q-tooltip>
              شماره چک
            </q-tooltip>
          </q-chip>
          <q-chip square icon="paid"
                  color="red" text-color="white"
          >
            {{ item.getFee | toCurrency }} ریال
            <q-tooltip>
              مبلغ چک
            </q-tooltip>
          </q-chip>
          <q-chip square icon="pin"
                  color="brown" text-color="white"
                  :label="item.VoucherNum">
            <q-tooltip>
              شماره سند
            </q-tooltip>
          </q-chip>
        </q-card-section>
      </q-card>
    </q-card-section>
    <q-card-section class="no-padding" v-if="!$q.screen.lt.md">
      <q-table
          table-style="max-height: 500px"
          :data="items"
          row-key="index"
          wrap-cells
          bordered
          :rows-per-page-options="[0]"
          :filter="filter">
        <template v-slot:header>
          <q-tr class="bg-blue-grey text-white fixed-header-position text-center">
            <td class="text-subtitle2">
              وضعیت سامانه صیاد
            </td>
            <td class="text-subtitle2">
              وضعیت
            </td>
            <q-td class="text-subtitle1">
              شماره چک
            </q-td>
            <q-td class="text-subtitle2">
              تاریخ چک
            </q-td>
            <q-td class="text-subtitle2">
              تاریخ رسید وجه در صندوق
            </q-td>
            <q-td class="text-subtitle2">
              شماره چک
            </q-td>
            <q-td class="text-subtitle2">
              مبلغ چک
            </q-td>
            <q-td class="text-subtitle2">
              شماره سند
            </q-td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="text-center">
            <td style="width: 300px">
              <q-select v-model="props.row.selectedChequeStatus"
                        :options="chequeStatus"
                        filled
                        dense
                        @input="(event)=> changeChequeStatus(event, props.row)"
                        option-value="id"
                        option-label="caption"
                        :disable="!$store.state.roles.some(v=>['admin','can_set_cheque_status'].includes(v))"
              />
            </td>
            <td>
              <q-chip square :color="props.row.RecoveryDate?'green':'red'" text-color="white"
                      :label="props.row.RecoveryDate?'پاس شده':'پاس نشده'"/>
            </td>
            <td>
              <q-chip square icon="account_balance"
                      :label="props.row.BankName">
              </q-chip>
            </td>
            <td>
              <q-chip square icon="event"
                      color="deep-orange" text-color="white"
                      :label="formatDateString(props.row.ExpiryDate)">
                <q-tooltip>
                  تاریخ چک
                </q-tooltip>
              </q-chip>
            </td>
            <td>
              <q-chip square icon="event"
                      v-if="props.row.RecoveryDate"
                      color="purple" text-color="white"
                      :label="formatDateString(props.row.RecoveryDate)">
                <q-tooltip>
                  تاریخ رسید وجه در صندوق
                </q-tooltip>
              </q-chip>
            </td>
            <td>
              <q-chip square icon="pin"
                      color="teal" text-color="white"
                      :label="props.row.ChequeNum">
                <q-tooltip>
                  شماره چک
                </q-tooltip>
              </q-chip>
            </td>
            <td>
              <q-chip square icon="paid"
                      color="red" text-color="white">
                {{ props.row.getFee | toCurrency }} ریال
                <q-tooltip>
                  مبلغ چک
                </q-tooltip>
              </q-chip>
            </td>
            <td>
              <q-chip square icon="pin"
                      color="brown" text-color="white"
                      :label="props.row.VoucherNum">
                <q-tooltip>
                  شماره سند
                </q-tooltip>
              </q-chip>
            </td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "CustomerPayBook",
  props: {
    CustomerInfo: {
      required: true
    },
    remCredit: {
      required: true
    }
  },
  data() {
    return {
      filter: '',
      items: [],
      selectedChequeStatus: undefined,
      chequeStatus: [
        {id: 1, caption: 'ثبت صدور چک توسط مشتری'},
        {id: 2, caption: 'ثبت دریافت چک توسط نوران'},
        {id: 3, caption: 'انتقال چک به فرد/سازمانی دیگر'}
      ]
    }
  },
  methods: {
    ...mapActions({
      getCustomerPayBook: 'Customers/getCustomerPayBook',
      changeStatus: 'Customers/setChequeStatus'
    }),
    removeSpecialCharacter(str) {
      return str.replace(/[#<>]/gi, ' ');
    },
    formatDateString(str) {
      let moment = require('jalali-moment');
      let MomentDate = moment(str, 'jYYYYjMMjDD');
      return MomentDate.locale('fa').calendar();
    },
    changeChequeStatus(event, rowInfo) {
      this.changeStatus({data: JSON.stringify(rowInfo)}).then((res) => {
        if (res.result === 1) {
          this.$q.notify({
            message: 'وضعیت چک ثبت شد',
            position: 'top',
            type: 'positive',
            color: 'positive'
          })
        }
      })
    }
  },
  created() {
    this.getCustomerPayBook(this.CustomerInfo.Cs_Code).then((res) => {
      res.forEach(rec => rec.selectedChequeStatus = rec.Status ? (this.chequeStatus.filter(item => item.caption === rec.Status)[0]) : undefined)
      this.items = res;
    })
  }
}
</script>

<style scoped>

</style>